module.exports = __webpack_public_path__ + "static/y4420_14-1d78c82049f7d8db7a814898b501bcd8.jpg";